var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "min-h-screen", attrs: { id: "app" } },
    [
      _c("router-view"),
      _c("LoginDialog", {
        attrs: { visible: _vm.isLoggedDialogVisible },
        on: { close: _vm.handleLoginClose },
      }),
      _c("RegisterDialog", {
        attrs: { visible: _vm.isRegisterDialogVisible },
        on: { close: _vm.handleRegisterClose },
      }),
      _c("InviteRegisterDialog", {
        attrs: { visible: _vm.isInviteRegisterDialogVisible },
        on: { close: _vm.handleInviteRegisterClose },
      }),
      _c(
        "CommonDialog",
        {
          attrs: {
            title: this.$t("login.registerTitle"),
            visible: _vm.isNewRegister,
            buttons: [
              {
                text: this.$t("common.confirm"),
                type: "primary",
                action: "cancel",
              },
            ],
          },
          on: {
            "update:visible": function ($event) {
              _vm.isNewRegister = $event
            },
            "button-click": _vm.handleDialog,
            close: _vm.handleDialog,
          },
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _c("div", { staticClass: "mb-4" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("login.registerSuccess")) +
                  _vm._s(_vm.couponAmount) +
                  " " +
                  _vm._s(_vm.$t("login.registerSuccessDesc")) +
                  " "
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }